import { render, staticRenderFns } from "./bgNumField.vue?vue&type=template&id=18a9aadb&scoped=true&"
import script from "./bgNumField.vue?vue&type=script&lang=js&"
export * from "./bgNumField.vue?vue&type=script&lang=js&"
import style0 from "./bgNumField.vue?vue&type=style&index=0&id=18a9aadb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a9aadb",
  null
  
)

export default component.exports